import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './BaseModalLayout.st.css.js';
import { labels, dataHooks } from './constants';
import CloseButton from '../CloseButton';
import { Help24 as Help } from '@wix/wix-ui-icons-common/system';
import { ThemeProviderConsumerBackwardCompatible } from '../ThemeProvider/ThemeProviderConsumerBackwardCompatible';
import { BaseModalLayoutContext } from './BaseModalLayoutContext';
import { Header, Content, Footer, Footnote, Illustration, } from './LayoutBlocks';
import Box from '../Box';
import IconButton from '../IconButton';
const classNames = {
    headerClassName: classes.header,
    contentClassName: classes.content,
    footerClassName: classes.footer,
    footnoteClassName: classes.footnote,
    illustrationClassName: classes.illustration,
};
const BaseModalLayout = ({ dataHook, className, children, style, onCloseButtonClick, onHelpButtonClick, skin = 'standard', ...restProps }) => {
    const controlButtonAmount = [onCloseButtonClick, onHelpButtonClick].filter(Boolean).length;
    return (React.createElement("div", { "data-hook": dataHook, "data-skin": skin, style: style, className: st(classes.root, { skin, controlButtonAmount }, className) },
        controlButtonAmount > 0 && (React.createElement(ThemeProviderConsumerBackwardCompatible, { defaultIcons: {
                BaseModalLayout: {
                    HelpIcon: Help,
                },
            } }, ({ icons: { BaseModalLayout: { HelpIcon }, }, }) => (React.createElement(Box, { direction: "horizontal", className: classes.controlButtons },
            onHelpButtonClick && (React.createElement(IconButton, { dataHook: dataHooks.helpButton, className: classes.helpButton, onClick: onHelpButtonClick, size: "small", skin: "dark", priority: "tertiary", ariaLabel: labels.help },
                React.createElement(HelpIcon, { className: classes.helpIcon }))),
            onCloseButtonClick && (React.createElement(CloseButton, { dataHook: dataHooks.closeButton, className: classes.closeButton, onClick: onCloseButtonClick, size: "large", skin: "dark", "aria-label": labels.close })))))),
        React.createElement(BaseModalLayoutContext.Provider, { value: { ...restProps, skin, ...classNames } }, children)));
};
/** Private component to be used by all public modals. Represents the common internals of all modals */
BaseModalLayout.Header = Header;
BaseModalLayout.Content = Content;
BaseModalLayout.Footer = Footer;
BaseModalLayout.Footnote = Footnote;
BaseModalLayout.Illustration = Illustration;
BaseModalLayout.propTypes = {
    className: PropTypes.string,
    dataHook: PropTypes.string,
    onCloseButtonClick: PropTypes.func,
    onHelpButtonClick: PropTypes.func,
    skin: PropTypes.oneOf(['standard', 'premium', 'destructive']),
};
BaseModalLayout.displayName = 'BaseModalLayout';
export default BaseModalLayout;
//# sourceMappingURL=BaseModalLayout.js.map